import React from "react";
import { TableRow, TableCell, Typography } from "@mui/material";

export default function ErrorStateRow({ colSpan = 1, error }) {
  const message = typeof error === "string" ? error : (error?.message || "خطای نامشخص");
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center">
        <Typography variant="body2" color="error">
          {message}
        </Typography>
      </TableCell>
    </TableRow>
  );
}


